import React from 'react';
import { useLocalStore, useObserver } from 'mobx-react';
import { ScoreDetailService } from '../../../../../../common/services';

const BasketballMatchLineupStore = () => {
  const store = useLocalStore(() => ({
    lineup: {
      home: {
        selection: [],
        candidate: [],
        impossible: [],
        id: 0,
        imgPath: '',
        name: '',
        shortName: ''
      },
      away: {
        selection: [],
        candidate: [],
        impossible: [],
        id: 0,
        imgPath: '',
        name: '',
        shortName: ''
      }
    },
    loading: true,
    init: false,
    gameId: null,
    get homeName() {
      return store.lineup.home.name;
    },
    get awayName() {
      return store.lineup.away.name;
    },
    get isEmpty() {
      const { lineup } = store;
      const { home, away } = lineup;

      return {
        selection: home.selection.length === 0 && away.selection.length === 0,
        candidate: home.candidate.length === 0 && away.candidate.length === 0
      };
    },
    get selection() {
      const { lineup } = store;
      const { home, away } = lineup;

      return { home: home.selection, away: away.selection };
    },
    get candidate() {
      const { lineup } = store;
      const { home, away } = lineup;

      return { home: home.candidate, away: away.candidate };
    },
    get impossible() {
      const { lineup } = store;
      const { home, away } = lineup;

      return { home: home.impossible, away: away.impossible };
    },
    async getLineup(gameId) {
      store.loading = true;
      try {
        const [result, impossiblePlayer] = await Promise.all([
          ScoreDetailService.getLineupBySportsType('basketball', gameId),
          store.getImpossiblePlayer(gameId)
        ]);

        if (!!result) {
          const deep = result;

          ['home', 'away'].forEach((key) => {
            deep[key] = {
              ...deep[key],
              selection: [],
              candidate: [],
              impossible: []
            };

            deep[key].additionalTeamData.forEach((player) => {
              if (player.started) {
                deep[key].selection.push(player);
              } else {
                deep[key].candidate.push(player);
              }
            });

            if (!!impossiblePlayer) {
              impossiblePlayer[key].additionalTeamData.forEach((player) => {
                deep[key].impossible.push(player);
              });
            }
          });

          store.lineup = deep;
        }
      } catch (error) {
        console.log(error);
      } finally {
        store.loading = false;
      }
    },
    async getImpossiblePlayer(gameId) {
      const result = await ScoreDetailService.getImpossiblePlayerByGameId(
        gameId
      );

      if (!!result) {
        return result;
      }
    }
  }));

  return {
    getLineup: store.getLineup,
    data: useObserver(() => {
      return {
        init: store.init,
        loading: store.loading,
        isEmpty: store.isEmpty,
        homeName: store.homeName,
        awayName: store.awayName,
        selection: store.selection,
        candidate: store.candidate,
        impossible: store.impossible,
      };
    })
  };
};

export default BasketballMatchLineupStore;
